import React from 'react';
import moment from 'moment';
import { inject, observer } from "mobx-react/index"
import { inventoryProduct } from "../../../../actions/api";
import { BASE_URL } from "../../../../config";

@inject('ticketStore', 'userStore', 'inventoryItemStore', 'inventoryProductStore')
@observer
export default class Log extends React.Component {

  imageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'bmp', 'gif'];

  renderAttachment = file => {
    let extension = file.split('.')[1],
      src = BASE_URL + '/mms-files' + file,
      fileName = file.split('/')[3];

    if (!!extension && this.imageExtensions.indexOf(extension.toLowerCase()) > -1) {
      return (
        <div className='log-attachment'>
          <a href={src} target='_blank'>
            <img height={60} width={60} src={src} alt={fileName} />
          </a>
        </div>
      );
    } else {
      return (
        <div className='log-attachment'>
          <a href={src} target='_blank'>
            <i className='fa fa-file-image-o' />
            <p>{fileName}</p>
          </a>
        </div>
      )
    }
  };


  render() {
    const { logs, date, userStore, inventoryItemStore, inventoryProductStore } = this.props;
    return (
      <div className='log-item'>
        <div className='flex flex-row space-around log-item-seperator'>
          <p>{moment(date).format('MMM D, YYYY')}</p>
        </div>
        {logs.sort((a, b) => (new Date(a.log_date)).valueOf() < (new Date(b.log_date)).valueOf() ? 1 : -1).map((log, i) => {
          let assignedTo = userStore.findById(log.assigned_to),
            inventoryItem = inventoryItemStore.findById(log.item_id),
            inventoryProduct = inventoryItem && inventoryProductStore.findById(inventoryItem.product_id);
          return <div key={`ticket_log_${log.log_date}`} className='log'>
            <div className='flex-grow'>
              <div className='log-item-info'>
                <strong>{log.name}</strong>
                <span color='light-gray'>-  {moment(log.log_date).format(' hh:mm A')}</span>
              </div>
              <div className='log-item-body'>
                {log.text.split('\n').map((line, i) => (
                  <p key={`ticket-log-${log.id}-${i}`}>{line}</p>
                ))}
              </div>
              <div className='log-item-footer'>
                {assignedTo && <p><b>Assigned to </b> : {assignedTo.name}</p>}
                {inventoryProduct && inventoryItem && <p><b>Item</b> : {inventoryProduct.pcategory_name} - {inventoryItem.serial_no}</p>}
              </div>
            </div>
            <div>
              {log.attachment_file && this.renderAttachment(log.attachment_file)}
            </div>
          </div>
        })}
      </div>
    );

    // let createdBy = userStore.findById(logs.user_id),
    //   assignedTo = userStore.findById(logs.assigned_to),
    //   inventoryItem = inventoryItemStore.findById(logs.item_id),
    //   inventoryProduct = inventoryItem && inventoryProductStore.findById(inventoryItem.product_id);
    //
    // return (
    //   <div className='log-item'>
    //     <div className='flex flex-row space-around log-item-seperator'>
    //       <p>{moment(logs.log_date).format('llll')}</p>
    //     </div>
    //     <div className='log-item-info'>{createdBy && createdBy.name}</div>
    //     <div className='log-item-body'>
    //       <p>{logs.text}</p>
    //       {logs.attachment_file && this.renderAttachment(logs.attachment_file)}
    //     </div>
    //     <div className='log-item-footer'>
    //       <p><b>Assigned to </b> : {assignedTo && assignedTo.name}</p>
    //       <p>{inventoryProduct && inventoryItem && <div><b>Item</b> : {inventoryProduct.pcategory_name} - {inventoryItem.serial_no}</div>}</p>
    //     </div>
    //   </div>
    // );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/Log/Log.js